import "../assets/vendor/nucleo/css/nucleo.css";
import "../assets/scss/argon.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import "../assets/scss/app.scss";
import "vuejs-noty/dist/vuejs-noty.css";
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import VueLazyload from "vue-lazyload";

export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(VueLazyload);
  }
};
